import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {getAdminEmpresa, getOperadorRemarcacao, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import baixarComprovanteReembolso from '../../actions/reserva/baixarComprovanteReembolso';
import selecionaReservaReembolsoSolicitado from '../../actions/reserva/selecionaReservaReembolsoSolicitado';

class AcoesRemarcacaoCancelamento extends Component {

  baixarComprovante(){
    baixarComprovanteReembolso(this.props.reserva.comprovanteReembolso, this.props.reserva.nomeComprovanteReembolso).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.props.reserva.nomeComprovanteReembolso);
          document.body.appendChild(link);

          link.click();

      });
  }

  exibirImprimirCupomCancelamento() {
    if (this.props.reserva.situacaoReserva === 'CANCELADO'
        || this.props.reserva.situacaoReserva === 'CANCELADO_REEMBOLSO_EFETUADO'
    ) {
      const url = `/recibo-cancelamento-reserva?reserva=${this.props.reserva.id}`;
      return (
        <div>
          <a className="dropdown-item"
             onClick={() => {
               this.props.history.push(url)
             }}> Emitir cupom de cancelamento
          </a>
        </div>
      )
    }
  }

  exibirDownloadComprovanteReembolso() {
    if (this.props.reserva.situacaoReserva === 'CANCELADO_REEMBOLSO_EFETUADO') {
      return (
        <a className="dropdown-item"
                title='Baixar'
                onClick={() => this.baixarComprovante()}>
            <i className="material-icons nav-icon" style={{
                color: '#fa8d42'
            }}>&#xe2c0;</i> Baixar Comprovante Reembolso
        </a>
      )
    }
  }

  exibirImprimirFormularioReembolso() {
    if (this.props.reserva.situacaoReserva === 'REEMBOLSO_SOLICITADO') {
      const url = `/painel-solicitacao-reembolso?reserva=${this.props.reserva.id}`;
      return (
        <div>
          <a className="dropdown-item"
             onClick={() => {
               this.props.history.push(url)
             }}> Imprimir Formulário Reembolso
          </a>
        </div>
      )
    }
  }

  exibirModalAnexarDocumentoReembolso() {
    if (this.props.reserva.situacaoReserva === 'REEMBOLSO_SOLICITADO') {      
      return (
        <div>
          <a className="dropdown-item" 
              href="#"
              data-toggle="modal" 
              data-target="#modalAnexaDocumentoReservasParaReembolsoEfetivado"
              onClick={() => {
                this.props.selecionaReservaReembolsoSolicitado(this.props.reserva)
              }}> Modal Anexar Documento Reembolso
          </a>
        </div>
      )
    }
  }

  render () {
    return (
      <div className="col">
        <div className="dropdown">
          <span className="titulo-mobile">Ações:</span>
          <button className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

            <i className="material-icons">
              &#xe5d4;
            </i>

          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <Autorizacao
              perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                  getOperadorRemarcacao(this.props.empresaSelecionada.id)]}>
               {this.exibirImprimirCupomCancelamento()}
               {this.exibirDownloadComprovanteReembolso()}
               {this.exibirImprimirFormularioReembolso()}
               {this.exibirModalAnexarDocumentoReembolso()}
            </Autorizacao>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
    {
      empresaSelecionada: state.empresaSelecionada
    });

export default withRouter(connect(mapStateToProps, { selecionaReservaReembolsoSolicitado })(AcoesRemarcacaoCancelamento))
